import instance from "./instance";
import axios from "axios";

export const cartToQuantity = (id, value, fromCart = false) => {
  return (dispatch) => {
    dispatch({
      type: "B2B_CART_TO_QUANTITY",
      payload: { value: value, id: id, fromCart: fromCart },
    });
  };
};

export const setUsedComponents = (payload) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_USED_COMPONENTS",
      payload: payload,
    });
  };
};
export const checkMOV = (cart, slug) => {
  return async (dispatch, getState) => {
    try {
      const res = await instance.post("/check_mov/", {
        cart: getState().b2b.cartToQuantity,
        slug: slug,
      });
      dispatch({
        type: "SET_MEET_MOV",
        payload: res.data == 1 ? true : false,
      });
    } catch (err) {
      console.error(err);
    }
  };
};

export const checkWalletBalance = (slug, phone, cart, method = null) => {
  return async (dispatch, getState) => {
    try {
      if (getState().b2b.method !== "on-credit" && method !== "on-credit")
        return;
      dispatch({ type: "BALANCE_CHECKING_LOADING", payload: true });
      const res = await instance.post("/check_b2b_wallet_balance/", {
        cart: cart,
        slug: slug,
        phone: phone,
      });

      dispatch({
        type: "CHECK_WALLET_BALLANCE",
        payload: res.data,
      });
      dispatch({ type: "BALANCE_CHECKING_LOADING", payload: false });
    } catch (err) {
      console.error(err);
    }
  };
};

export const setProduct = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_PRODUCT",
      payload: value,
    });
  };
};

export const setDistributor = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_DISTRIBUTOR",
      payload: value,
    });
  };
};

export const setBranchDetails = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_BRANCH_DETAILS",
      payload: value,
    });
  };
};

export const setPhoneNumber = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_PHONE_NUMBER",
      payload: value,
    });
  };
};

export const setVerifiedPhone = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_VERIFIED_PHONE",
      payload: value,
    });
  };
};

export const setMethod = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_METHOD",
      payload: value,
    });
  };
};
export const fetchCategories = (value) => {
  return (dispatch) => {
    dispatch({
      type: "FETCH_CATEGORIES",
      payload: value,
    });
  };
};

export const setB2BNoticeBannerVisibility = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_B2B_NOTICE_BANNER_VISIBILITY",
      payload: value,
    });
  };
};

export const dismissB2BNoticeBanner = () => {
  return (dispatch) => {
    dispatch({
      type: "DISMISS_B2B_NOTICE_BANNER",
    });
  };
};
